/**
 * LoadingSpinner — Shown during simulated data fetches
 */
import type { JSX } from 'preact'

interface LoadingSpinnerProps {
  /** Optional message to show below spinner */
  message?: string
  /** Size variant */
  size?: 'sm' | 'md' | 'lg'
}

export function LoadingSpinner({ message, size = 'md' }: LoadingSpinnerProps): JSX.Element {
  const sizeClass = size !== 'md' ? ` bw2-spinner--${size}` : ''
  return (
    <div className={`bw2-spinner${sizeClass}`} role="status" aria-label={message || 'Loading'}>
      <div className="bw2-spinner__circle" />
      {message && <p className="bw2-spinner__message">{message}</p>}
    </div>
  )
}
